import React from 'react';
import NeonDivider from './NeonDivider';

const CareersSection = () => {
  return (
    <section id="careers" className="py-20 px-4 bg-gradient-to-b from-black via-black/95 to-black">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-logoSans text-ivory mb-4">
          JOIN THE TEAM
        </h2>
        <p className="text-gray text-lg mb-8">
          Be part of the Billy's WingCo family. We're always looking for passionate people 
          who want to deliver legendary experiences.
        </p>

        <NeonDivider color="neonRed" />

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="p-6 border border-neonBlue/20 rounded-xl bg-black/30 backdrop-blur-sm">
            <h3 className="text-xl font-logoSans text-ivory mb-4">Current Openings</h3>
            <ul className="space-y-3 text-left">
              <li className="flex justify-between items-center py-2 border-b border-gray/10">
                <span className="text-gray">Kitchen Staff</span>
                <span className="text-neonBlue text-sm">Part/Full Time</span>
              </li>
              <li className="flex justify-between items-center py-2 border-b border-gray/10">
                <span className="text-gray">Servers</span>
                <span className="text-neonBlue text-sm">Part Time</span>
              </li>
              <li className="flex justify-between items-center py-2 border-b border-gray/10">
                <span className="text-gray">Bartender</span>
                <span className="text-neonBlue text-sm">Full Time</span>
              </li>
            </ul>
          </div>

          <div className="p-6 border border-neonRed/20 rounded-xl bg-black/30 backdrop-blur-sm">
            <h3 className="text-xl font-logoSans text-ivory mb-4">Why Work Here?</h3>
            <ul className="space-y-2 text-left text-gray">
              <li>• Competitive wages</li>
              <li>• Flexible scheduling</li>
              <li>• Staff meal discounts</li>
              <li>• Growth opportunities</li>
              <li>• Fun team environment</li>
            </ul>
          </div>
        </div>

        <div className="space-y-6">
          <h3 className="text-2xl font-logoSans text-ivory">Ready to Apply?</h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:careers@billyswingco.com"
              className="bg-neonBlue text-black px-8 py-3 rounded-lg font-semibold
                         shadow-neonBlue hover:animate-flicker hover:-translate-y-0.5
                         transition-all duration-200 inline-flex items-center justify-center"
            >
              Email Resume
            </a>
            <a
              href="#contact"
              className="border-2 border-neonRed text-neonRed px-8 py-3 rounded-lg 
                         font-semibold hover:bg-neonRed hover:text-black hover:shadow-neonRed 
                         hover:-translate-y-0.5 transition-all duration-200 inline-flex 
                         items-center justify-center"
            >
              Apply In Person
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersSection; 